import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "filter-white",
  "use": "filter-white-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"filter-white\"><path d=\"M13.352 0H.646A.594.594 0 00.06.387c-.113.272-.066.503.139.695l4.894 4.894V10.8c0 .172.063.321.189.446l2.541 2.541a.589.589 0 00.447.19c.08 0 .162-.017.248-.05.258-.113.388-.308.388-.585V5.976L13.8 1.082c.205-.192.25-.423.138-.695A.594.594 0 0013.352 0z\" fill=\"#FFF\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol